import type { ReactNode } from 'react';
import { HubBackLink } from '@/components/hub/HubBackLink';

interface HubDetailPageHeaderProps {
  backTo: string;
  backLabel: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function HubDetailPageHeader({
  backTo,
  backLabel,
  title,
  description,
  actions,
}: HubDetailPageHeaderProps) {
  return (
    <header className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
      <div className="flex items-start gap-4">
        <HubBackLink to={backTo} label={backLabel} />
        <div className="min-w-0 flex-1">
          <h1 className="text-3xl font-semibold text-dash-primary md:text-4xl">{title}</h1>
          {description ? (
            <p className="mt-1 max-w-2xl text-dash-on-surface-variant">{description}</p>
          ) : null}
        </div>
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-3">{actions}</div> : null}
    </header>
  );
}
